import React from "react";

const CBRefernceModal = () => {
  return <div>CBRefernceModal CBRefernceModal</div>;
};

export default CBRefernceModal;
